import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import SectionHeader from './SectionHeader';

export default function Featured() {
  const list = comics.filter((c) => c.featured).slice(0, 3);
  return (
    <section className="section-pad bg-background-50">
      <div className="container-page">
        <SectionHeader
          eyebrow="反转剧场"
          title="开局平凡，结尾直接封神"
          desc="编辑部精选的超级反转作品，每一话都是神展开，猜中结局算你赢。"
          linkTo="/category/reversal"
          linkLabel="进入反转剧场"
        />
        <div className="flex flex-col gap-8">
          {list.map((comic, index) => (
            <article
              key={comic.id}
              className={`flex flex-col items-center gap-6 rounded-3xl border border-background-200/70 bg-background-100 p-5 md:p-6 lg:flex-row lg:gap-10 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className="w-full shrink-0 lg:w-64">
                <Link to={`/comic/${comic.id}`} className="block overflow-hidden rounded-2xl">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}漫画封面`}
                    className="aspect-[3/4] w-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                </Link>
              </div>
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                    TOP {index + 1} 神展开
                  </span>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
                    {comic.category}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-600">
                    <i className="ri-fire-line text-primary-500" aria-hidden="true" />
                    {comic.views} 次阅读
                  </span>
                </div>
                <h3 className="mt-3 text-xl text-foreground-950 md:text-2xl">
                  <Link to={`/comic/${comic.id}`} className="transition-colors hover:text-primary-600">
                    {comic.title}
                  </Link>
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                  {comic.description}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {comic.tags.map((tag) => (
                    <span key={tag} className="rounded-md bg-background-200/80 px-2 py-1 text-xs text-foreground-600">
                      #{tag}
                    </span>
                  ))}
                </div>
                <Link
                  to={`/comic/${comic.id}`}
                  className="mt-5 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  立即开看
                  <i className="ri-play-circle-line" aria-hidden="true" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}